import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/services/notification.service';
import { PricingService } from '../../../shared/services/pricing.service';
import { PricingGroupFormComponent } from '../pricing-group-form/pricing-group-form.component';

@Component({
  standalone: false,
  selector: 'app-pricing-group-update',
  templateUrl: './pricing-group-update.component.html',
})
export class PricingGroupUpdateComponent implements OnInit {
  @ViewChild(PricingGroupFormComponent, { static: false }) form: PricingGroupFormComponent;

  loading = false;

  constructor(
    public pricingService: PricingService,
    public router: Router,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    titleService: Title
  ) {
    titleService.setTitle('Pricing group update');
  }

  afterSave() {
    this.router.navigate(['/pricing-general']).then();
  }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.params['id']);
    this.loading = true;
    this.pricingService.oneGroup(id).subscribe(
      group => {
        group.bundles = [];
        group.tiers = [];
        const errorHandler = err => {
          this.loading = false;
          this.notificationService.error({
            title: 'General pricing',
            message: 'An error occurred while loading the bundles/tiers',
            serviceName: 'GATEWAY',
            requestMessage: err.statusText,
            requestCode: err.status,
            ts: err.timestamp ? err.timestamp : null,
          });
        };
        if (group.paymentType === 'PREPAID') {
          this.pricingService.bundles(id).subscribe(items => {
            group.bundles = items.map(item => {
              item.serviceType = item.serviceType === 'VOICE' ? 'CLI' : item.serviceType;
              return item;
            });
            this.form.model = group;
            this.loading = false;
          }, errorHandler);
        } else {
          this.pricingService.tiers(id).subscribe(items => {
            group.tiers = items.map(item => {
              item.serviceType = item.serviceType === 'VOICE' ? 'CLI' : item.serviceType;
              return item;
            });
            this.form.model = group;
            this.loading = false;
          }, errorHandler);
        }
      },
      error => {
        this.notificationService.error({
          title: 'General pricing',
          message: 'An error occurred while loading the pricing group',
          serviceName: 'GATEWAY',
          requestMessage: error.statusText,
          requestCode: error.status,
          ts: error.timestamp ? error.timestamp : null,
        });
      }
    );
  }
}
